import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "md:my-28 mt-3 grid gap-y-5"
}
const _hoisted_2 = { class: "text-xl md:text-2xl font-medium" }
const _hoisted_3 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_4 = { class: "p-2 col-span-12 md:col-span-9" }
const _hoisted_5 = { class: "text-lg font-bold" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-3 my-4"
}
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { id: "btn-radio" }
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col my-4"
}
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "w-4/12 mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Para adicionar materiais ') + " "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://wp.homero.app.br/wp-admin/admin.php?page=h5p",
    target: "_blank",
    class: "text-h-primary-500 font-bold cursor-pointer"
  }, /*#__PURE__*/_toDisplayString('Clique aqui'))
], -1)
const _hoisted_16 = { class: "flex flex-col gap-3 my-4" }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = {
  id: "btn-radio",
  class: "flex gap-5"
}
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = ["for"]
const _hoisted_21 = {
  key: 0,
  id: "certificate",
  class: "my-3"
}
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { class: "w-4/12" }
const _hoisted_24 = { class: "flex flex-col my-4" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "flex flex-col my-4" }
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = {
  class: "flex flex-col my-4",
  id: "dropzone-files"
}
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = { class: "flex flex-col my-4" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "flex flex-col my-4" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { class: "flex flex-col my-4" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "flex items-center gap-3 col-span-12 mt-10" }
const _hoisted_37 = { class: "p-2 col-span-3 hidden md:flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Dropzone = _resolveComponent("Dropzone")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CardView = _resolveComponent("CardView")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("course.form.add")), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submitCourse()), ["prevent"])),
                autocomplete: "off"
              }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("course.form.subtitle")), 1),
                (!_ctx.isEditable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Tipo de curso",
                    en: "Course type",
                  })), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(`flex gap-9 items-center ${_ctx.v$.form.courseType.$error ? 'border border-red-500 p-3' : ''
                } rounded-md w-fit`)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radios, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_RadioButton, {
                                  id: "radio-adaptive",
                                  modelValue: _ctx.form.courseType,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.courseType) = $event)),
                                  inputId: item.name,
                                  value: item.value,
                                  disabled: item.disabled,
                                  name: "courseType",
                                  class: "custom-radio"
                                }, null, 8, ["modelValue", "inputId", "value", "disabled"]),
                                _createElementVNode("label", {
                                  for: item.name,
                                  class: _normalizeClass(`ml-2 cursor-pointer ${item.disabled ? 'text-gray-400' : ''
                        }`)
                                }, _toDisplayString(item.name), 11, _hoisted_10)
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                _createVNode(_component_v_icon, {
                                  name: "md-info-outlined",
                                  class: "text-h-primary-500"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  `
                          ${item.value == 'ADAPTATIVE'
                        ? _ctx.$t('course.form.types.adaptive')
                        : item.value == 'LINEAR'
                          ? _ctx.$t('course.form.types.traditional')
                          : item.value == 'INTERACTIVE'
                            ? _ctx.$t('course.form.types.interactive')
                            : ''
                      }
                        `
                      ,
                                  void 0,
                                  { bottom: true }
                                ]
                              ])
                            ])
                          ]))
                        }), 128))
                      ], 2),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.form.courseType.$errors
                      }, null, 8, ["errors"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.courseType === 'INTERACTIVE')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("course.form.materialInteractive")), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_AutoComplete, {
                            id: "predecessor-input",
                            modelValue: _ctx.form.course.material,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.course.material) = $event)),
                            suggestions: _ctx.materials,
                            forceSelection: true,
                            placeholder: _ctx.$t('course.form.materialInteractiveDescription'),
                            optionLabel: "title",
                            class: _normalizeClass([
                    'w-full',
                    _ctx.v$.form.course.material.$error ? 'p-invalid' : '',
                  ]),
                            onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForMaterials($event))),
                            dropdown: ""
                          }, null, 8, ["modelValue", "suggestions", "placeholder", "class"]),
                          _createVNode(_component_Errors, {
                            errors: _ctx.v$.form.course.material.$errors
                          }, null, 8, ["errors"])
                        ]),
                        _hoisted_15
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("course.form.hasCertificate")), 1),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificate, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_RadioButton, {
                            id: "radio-certificate",
                            modelValue: _ctx.form.course.hasCertificate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.course.hasCertificate) = $event)),
                            inputId: item.name,
                            value: item.value,
                            name: "hasCertificate",
                            class: "custom-radio"
                          }, null, 8, ["modelValue", "inputId", "value"]),
                          _createElementVNode("label", {
                            for: item.name,
                            class: _normalizeClass(`ml-2 cursor-pointer`)
                          }, _toDisplayString(item.name), 9, _hoisted_20)
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.form.course.hasCertificate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("course.form.certificateType")), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_AutoComplete, {
                            id: "predecessor-input",
                            modelValue: _ctx.form.course.certificate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.course.certificate) = $event)),
                            suggestions: _ctx.certificates,
                            forceSelection: true,
                            placeholder: _ctx.$t('course.form.certificatePlaceholder'),
                            optionLabel: "name",
                            class: _normalizeClass([
                      'w-full',
                      _ctx.v$.form.course.certificate.$error ? 'p-invalid' : '',
                    ]),
                            onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchForCertificates($event))),
                            dropdown: ""
                          }, null, 8, ["modelValue", "suggestions", "placeholder", "class"]),
                          _createVNode(_component_Errors, {
                            errors: _ctx.v$.form.course.certificate.$errors
                          }, null, 8, ["errors"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("course.form.name")), 1),
                  _createVNode(_component_InputText, {
                    id: "name-input",
                    type: "text",
                    modelValue: _ctx.form.course.name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.course.name) = $event)),
                    class: _normalizeClass(_ctx.v$.form.course.name.$error ? 'p-invalid' : ''),
                    maxlength: 40
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.course.name.$errors,
                    actualLength: _ctx.form.course.name?.length,
                    maxLength: 40
                  }, null, 8, ["errors", "actualLength"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("course.form.duration")), 1),
                  _createVNode(_component_InputMask, {
                    id: "name-input",
                    type: "text",
                    modelValue: _ctx.form.course.duration,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.course.duration) = $event)),
                    mask: "999:99:99",
                    placeholder: "00:00:00",
                    class: _normalizeClass(_ctx.v$.form.course.duration.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.course.duration.$errors,
                    actualLength: _ctx.form.course.duration?.length
                  }, null, 8, ["errors", "actualLength"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("course.form.thumb")), 1),
                  _createVNode(_component_Dropzone, {
                    files: _ctx.form.files,
                    errors: _ctx.v$.form.files.$errors,
                    acceptFiles: `.jpg,.jpeg,.png`,
                    onOnThumbnailView: _ctx.loadThumbnail,
                    onOnRemoveThumbnailView: _ctx.removeThumbnail
                  }, null, 8, ["files", "errors", "acceptFiles", "onOnThumbnailView", "onOnRemoveThumbnailView"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("course.form.categories")), 1),
                  _createVNode(_component_AutoComplete, {
                    id: "categories-input",
                    optionLabel: "name",
                    modelValue: _ctx.form.course.categories,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.course.categories) = $event)),
                    suggestions: _ctx.autocomplete.sugestions,
                    multiple: true,
                    forceSelection: true,
                    delay: 500,
                    class: _normalizeClass(_ctx.v$.form.course.categories.$error ? 'p-invalid' : ''),
                    onComplete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchForCategories($event))),
                    onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.addNewCategories($event)), ["enter"]))
                  }, null, 8, ["modelValue", "suggestions", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.course.categories.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("course.form.description")), 1),
                  _createVNode(_component_Textarea, {
                    id: "description-input",
                    autoResize: true,
                    rows: "5",
                    cols: "30",
                    modelValue: _ctx.form.course.description,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.course.description) = $event)),
                    class: _normalizeClass(_ctx.v$.form.course.description.$error ? 'p-invalid' : ''),
                    maxlength: 200
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.course.description.$errors,
                    actualLength: _ctx.form.course.description?.length,
                    maxLength: 200
                  }, null, 8, ["errors", "actualLength"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Ementa ",
                    en: "Summary",
                  })), 1),
                  _createVNode(_component_Editor, {
                    id: "summary-input",
                    modelValue: _ctx.form.course.summary,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.course.summary) = $event)),
                    editorStyle: "height: 400px",
                    class: _normalizeClass(_ctx.v$.form.course.summary.$error
                ? 'border border-red-500 rounded-md'
                : ''
                )
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.course.summary.$errors,
                    actualLength: _ctx.form.course.summary?.length,
                    maxLength: 5000
                  }, null, 8, ["errors", "actualLength"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_Button, {
                    id: "cancel-btn",
                    label: "Cancelar",
                    class: "btn-outline",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.confirmModal()))
                  }),
                  _createVNode(_component_Button, {
                    id: "submit-btn",
                    type: "submit",
                    label: "Salvar",
                    class: "btn-primary"
                  })
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_CardView, {
                id: "card-course",
                thumbnail: _ctx.viewThumbnail,
                title: _ctx.form.course.name,
                description: _ctx.form.course.description,
                categories: _ctx.form.course.categories
              }, null, 8, ["thumbnail", "title", "description", "categories"])
            ])
          ]),
          _createVNode(_component_ConfirmDialog)
        ]))
      : _createCommentVNode("", true)
  ]))
}